<template>
  <div
    style="height: inherit"
    class="mb-5"
  >

    <b-overlay
      :show="loader.content"
      opacity="0.50"
      rounded="sm"
    >
      <!-- ECommerce Header -->
      <headerECommerce
        :filters="filters"
        :ciclo-escolar="cicloEscolar"
        :shop-products="shopProducts"
        :shop-products-package="shopProductsPackage"
        :item-view="itemView"
        @ShowLeftSidebar="mqShallShowLeftSidebar = true"
        @loadShopItems="loadShopItems"
        @changeViewStyle="itemView = $event;"
      />

      <!-- Overlay -->
      <div class="body-content-overlay" />

      <!-- Searchbar -->
      <searchbarECommerce :filters="filters" />

      <!-- Package Items -->
      <packageItems
        :item-view="itemView"
        :loader="loader"
        :shop-products-package="shopProductsPackage"
      />

      <hr class="mt-5 mb-5">

      <!-- Materias Items -->
      <!-- <materiasItems
        :item-view="itemView"
        :loader="loader"
        :shop-products="shopProducts"
      /> -->

    </b-overlay>

    <!-- Sidebar -->
    <portal to="content-renderer-sidebar-detached-left">
      <shop-left-filter-sidebar
        :filters="filters"
        :mq-shall-show-left-sidebar.sync="mqShallShowLeftSidebar"
        @borrarFiltros="cleanFilters"
        @loadShopItems="loadShopItems"
      />
    </portal>
  </div>
</template>

<script>
import { BOverlay } from 'bootstrap-vue'
import { useResponsiveAppLeftSidebarVisibility } from '@core/comp-functions/ui/app'
import { ref, computed, onMounted } from '@vue/composition-api'
import store from '@/store/index'
import { formhttp } from '@core/utils/utils'
import { useEcommerce } from '@/views/campus/e-commerce/useEcommerce'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ShopLeftFilterSidebar from './components/ECommerceShopLeftFilterSidebar.vue'
import HeaderECommerce from './components/HeaderECommerce.vue'
import SearchbarECommerce from './components/SearchbarECommerce.vue'
import PackageItems from './components/content-items/Package-Items.vue'
// import MateriasItems from './components/content-items/Materias-Items.vue'

export default {
  components: {
    HeaderECommerce,
    SearchbarECommerce,
    PackageItems,
    // MateriasItems,
    BOverlay,
    ShopLeftFilterSidebar,
  },
  setup() {
    const filters = ref({
      especialidad: '',
      temporalidad: {},
      search: '',
      contenido: { text: 'Materias', value: 1 },
      ciclo: {},
    })
    const cicloEscolar = ref([])
    const itemView = ref('grid-view')
    const loader = ref({ filters: false, content: false })
    const { cicloEscolarDisponible, fetchShopItems } = useEcommerce()
    const { mqShallShowLeftSidebar } = useResponsiveAppLeftSidebarVisibility()
    const shopProducts = computed(() => store.getters['eCommerce/getFilteredStore'](filters.value))
    const shopProductsPackage = computed(() => store.getters['eCommerce/getFilteredStorePackage'](filters.value))
    const toast = useToast()

    const loadShopItems = () => {
      // filters.value.especialidad = especialidad.plan_id
      loader.value.filters = true // Start loader - change ref value (true)
      loader.value.content = true // Start loader - change ref value (true)

      fetchShopItems(filters.value).then(response => {
        loader.value.filters = false // Stop loader - change ref value (false)
        loader.value.content = false // Stop loader - change ref value (false)
        // se agrega un control de mensajes
        const { icon, label } = formhttp(response.status)

        toast({
          component: ToastificationContent,
          props: {
            // title: 'Solicitud de contenido',
            text: response.message,
            icon,
            variant: label,
          },
        },
        { timeout: 8000 })
      }, error => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Atención',
            text: error,
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        },
        { timeout: 8000 })
        loader.value.filters = false // Stop loader - change ref value (false)
        loader.value.content = false // Stop loader - change ref value (false)
      })
    }

    const cleanFilters = () => {
      filters.value.temporalidad = 0
      filters.value.contenido = { text: 'Materias', value: 1 }
      filters.value.search = ''
    }

    onMounted(
      () => {
        loader.value.content = true
        cicloEscolarDisponible().then(response => {
          loader.value.content = false // Stop loader - change ref value (false)
          // eslint-disable-next-line prefer-destructuring
          filters.value.ciclo = response.data[0]
          cicloEscolar.value = response.data
        }, error => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error en solicitud [ciclos escolares]',
              text: error,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 8000 })
          loader.value.content = false // Stop loader - change ref value (false)
        })
      },
    )

    return {
      mqShallShowLeftSidebar,
      filters,
      cicloEscolar,
      itemView,
      loader,
      shopProducts,
      shopProductsPackage,
      loadShopItems,
      cleanFilters,
    }
  },
}
</script>

<style lang="scss">
@import "~@core/scss/base/pages/app-ecommerce.scss";
</style>
